import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'react-bootstrap/lib/Tooltip';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';

class LabelClaro extends React.Component {
  render() {
    const tooltip =
      this.props.labelTip === undefined ? (
        ''
      ) : (
        <Tooltip id="myTooltip">{this.props.labelTip}</Tooltip>
      );
    const tipLabel =
      this.props.labelTip === undefined ? (
        ''
      ) : (
        <OverlayTrigger placement="top" overlay={tooltip}>
          <a tabIndex="-1" href="#">
            (?)
          </a>
        </OverlayTrigger>
      );

    if (this.props.htmlText) {
      return (
        <div>
          <div dangerouslySetInnerHTML={{ __html: this.props.labelInf }} />
          <div
            dangerouslySetInnerHTML={{ __html: this.props.htmlText }}
            style={{ display: 'inline' }}
          />
          <label
            className={this.props.className}
            htmlFor={this.props.idElement}
          >
            {this.props.labelText} {tipLabel}
          </label>
        </div>
      );
    }

    return (
      <label className={this.props.className} htmlFor={this.props.idElement}>
        {this.props.labelText} {tipLabel}
      </label>
    );
  }
}

LabelClaro.propTypes = {
  htmlFor: PropTypes.string.isRequired,
  labelText: PropTypes.string,
  htmlText: PropTypes.string,
  labelTip: PropTypes.string,
};

export default LabelClaro;
